import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { EMOJI_CATEGORIES, readEmojiTab, writeEmojiTab } from "@/lib/emojiSets";

// Lot 634 — grille d'émojis à 3 onglets (Foi · Émotions · Vie & musique), partagée par le chat, les commentaires, le composeur
// et les stickers de story. `tapProps(fn)` : props du bouton (keepFocusTap pour ne pas fermer le clavier) — défaut onClick.
const COLS = { 6: "grid-cols-6", 8: "grid-cols-8" };

export const EmojiTabsGrid = ({ onPick, cols = 8, cell = "h-7 w-7 text-lg", dark = false, gridTestId = "emoji-grid", itemTestId = (e) => `emoji-${e}`, tapProps = (fn) => ({ onClick: fn }) }) => {
  const { t } = useApp();
  const [tab, setTab] = useState(readEmojiTab);
  const cat = EMOJI_CATEGORIES.find((c) => c.key === tab) || EMOJI_CATEGORIES[0];
  const pick = (key) => { setTab(key); writeEmojiTab(key); };
  const tabBase = dark ? "text-white/70" : "";
  const tabOn = dark ? { background: "rgba(255,255,255,0.18)", color: "#fff" } : { background: "var(--yalola-primary)", color: "#fff" };
  const tabOff = dark ? { background: "rgba(255,255,255,0.06)" } : { background: "var(--yalola-surface-alt)", color: "var(--yalola-text-muted)" };
  return (
    <div data-testid={`${gridTestId}-tabs-wrap`} data-tab={cat.key}>
      <div className="flex gap-1 mb-1.5" role="tablist" data-testid={`${gridTestId}-tabs`}>
        {EMOJI_CATEGORIES.map((c) => (
          <button key={c.key} type="button" role="tab" aria-selected={c.key === cat.key} {...tapProps(() => pick(c.key))}
            className={`flex-1 min-w-0 truncate rounded-full px-1.5 py-1 text-[11px] font-semibold leading-none transition-colors ${tabBase}`}
            style={c.key === cat.key ? tabOn : tabOff} data-testid={`${gridTestId}-tab-${c.key}`}>
            <span className="mr-0.5">{c.icon}</span>{t(c.labelKey, c.label)}
          </button>
        ))}
      </div>
      <div className={`grid ${COLS[cols] || COLS[8]} gap-1`} data-testid={gridTestId} data-count={cat.emojis.length}>
        {cat.emojis.map((e) => (
          <button key={e} type="button" {...tapProps(() => onPick(e))}
            className={`${cell} grid place-items-center rounded-lg leading-none transition-transform hover:scale-110 active:scale-125 ${dark ? "" : "hover:bg-[color:var(--yalola-surface-alt)]"}`}
            data-testid={itemTestId(e)}>
            {e}
          </button>
        ))}
      </div>
    </div>
  );
};
